// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__KI1Tn","ranges":"BmiRanges_ranges__1fgbB"};